export const CANCEL_MODE_STANDARD = 'cancel_mode_standard';
export const CANCEL_MODE_OFF = 'cancel_mode_off';
export const CANCEL_MODE_CUSTOM_REASONS = 'cancel_mode_custom_reasons';
export const CANCEL_MODE_SPECIAL_INSTRUCTION = 'cancel_mode_special_instruction';

export const RESPONSE_INCENTIVE_TYPE_OFFERS = 'response_incentive_type_offers';
export const RESPONSE_INCENTIVE_TYPE_CUSTOM_TEXT = 'response_incentive_type_custom_text';

export const OFFER_TYPE_DISCOUNT_CODE = 'offer_type_discount_code';
export const OFFER_TYPE_SKIP_SHIPMENT = 'offer_type_skip_shipment';
export const OFFER_TYPE_SWAP_PRODUCT = 'offer_type_swap_product';
export const OFFER_TYPE_MODIFY_QUANTITY = 'offer_type_modify_quantity';
export const OFFER_TYPE_PAUSE_SUBSCRIPTION = 'offer_type_pause_subscription';



// WEBPACK FOOTER //
// ./src/constants/OrderCancellationStates.js